export default {
    modalInformesAgendados: false,
    empresas: [],
    selectedEmpresa: {
        id: ''
    },
    filtrosBusqueda: {
        fecha: null,
    },
    informesProcesados: [],
    informe: ''
} 